<template>
  <div>
    <q-inner-loading :showing="visible" class="fullscreen">
      <q-spinner size="50px" color="secondary" />
    </q-inner-loading>
    <!-- Category Filter Menu -->
    <section class="latest-news-filter" v-if="hasData">
      <div class="latest-news-filter__actions">
        <q-btn
          :color="this.tab === 'All' ? 'secondary' : 'white'"
          :class="this.tab === 'All' ? 'text-white' : 'text-black'"
          rounded
          unelevated
          label="All"
          class="q-mr-sm"
        />
        <span v-for="(category, index) in categories" :key="index">
          <q-btn
            v-if="category.NewsItems.length > 0"
            @click="openNewsCategory(category.Name, category.id)"
            rounded
            unelevated
            :color="tab === category.Name ? 'secondary' : 'white'"
            :class="tab === category.Name ? 'text-white' : 'text-black'"
            class="q-mr-sm"
            :label="category.Name"
          />
        </span>
      </div>
      <!-- Toogle list view / grid view -->
      <div class="latest-news-filter__toogle">
        <q-btn
          unelevated
          rounded
          text-color="secondary"
          round
          :outline="$q.dark.isActive ? true : false"
          color="white"
          :icon="isListView ? 'grid_view' : 'view_list'"
          @click="toggleListView()"
        >
          <q-tooltip>
            Switch to {{ isListView ? "list" : "grid" }} view
          </q-tooltip>
        </q-btn>
      </div>
    </section>
    <!-- List of Categories in CMS -->
    <section v-if="hasData" class="latest-news-container">
      <div
        class="latest-news-category"
        :class="displayClass"
        v-for="category in categories"
        :key="category.Name"
        :id="category.Name"
      >
        <div
          class="latest-news-category__title"
          v-if="category.NewsItems.length >= 1"
        >
          {{ category.Name
          }}<q-btn
            unelevated
            rounded
            text-color="black"
            color="white"
            label="See More"
            @click="openNewsCategory(category.Name, category.id)"
          />
        </div>
        <article
          v-for="item in category.NewsItems.slice(0, 3)"
          :key="item.id"
          class="latest-news-category__item"
        >
          <div v-if="item.Image !== null" class="latest-news-category__image">
            <img
              :src="item.Image.url"
              :alt="item.Image.alternativeText"
              :title="item.Image.alternativeText"
            />
          </div>
          <div class="latest-news-category__content">
            <div class="latest-news-category__date">
              <div class="latest-news-category__date-pill">
                {{ formatDateTime(item.Date) }}
              </div>
            </div>
            <div class="latest-news-category__header">
              {{ item.Title }}
            </div>
            <div class="latest-news-category__snippet">
              <p
                :inner-html.prop="truncateText(convertMarkdown(item.Body), 180)"
              ></p>
            </div>
            <div class="latest-news-category__actions">
              <q-btn
                unelevated
                color="secondary"
                label="Read More"
                @click="openNewsItem(category.Name, item.id, item.Title)"
                no-caps
              />
            </div>
          </div>
        </article>
      </div>
    </section>
    <NoData
      v-if="!hasData"
      label="Latest news could not be loaded, please contact the system administrator."
    />
  </div>
</template>

<script>
import router from "@/router";
import NoData from "@/components/other/NoData.vue";
import { formatDateTime } from "@/utils/formatDate";
import { formatUrl, truncateText, convertMarkdown } from "@/utils/formatText";
import { getStrapiContent } from "@/services/strapi-content/strapiContent";

export default {
  name: "NewsAll",
  data() {
    return {
      categories: [],
      isListView: true,
      displayClass: "list",
      visible: false,
      hasData: true,
      tab: "All",
    };
  },
  components: {
    NoData,
  },
  methods: {
    formatDateTime,
    truncateText,
    convertMarkdown,
    fetchNewsCategories() {
      this.visible = true;
      getStrapiContent("news-categories")
        .then((response) => {
          // Assign response to this.categories to allow markup to look through objects
          if (response && response.data) {
            this.categories = this.transformData(response.data);
            (this.hasData = true), (this.visible = false);
          } else {
            this.visible = false;
            this.hasData = false;
          }
        })
        .catch((error) => {
          this.errors.push(error);
          this.hasData = false;
        });
    },

    newsItemSorter(a, b, ascending) {
      // 1 > -1 ASC
      if (a.id < b.id) {
        return ascending ? -1 : 1;
      }
      // -1 > 1 ASC
      if (a.id > b.id) {
        return ascending ? 1 : -1;
      }
      return 0;
    },

    sortNewsItems(newsItems) {
      return newsItems.sort(this.newsItemSorter);
    },

    transformData(newCategories) {
      return newCategories.map((newsCategory) => {
        newsCategory.NewsItems = this.sortNewsItems(newsCategory.NewsItems);
        return newsCategory;
      });
    },

    toggleListView() {
      // Toggle the display of the news itesm using a class switcher
      if (this.isListView) {
        // Update dynamic class name
        this.displayClass = "grid";
      } else {
        // Update dynamic class name
        this.displayClass = "list";
      }
      this.isListView = !this.isListView;
    },
    openNewsCategory(categoryName, id) {
      // Push category and article id to router and "NewsItem.vue" component.
      // - Category converted to lowercase and pushed to generate the url slug
      // - Id used to fetch the article from strapi
      const name = formatUrl(categoryName);
      router.push({
        name: "News Category",
        params: {
          name,
          id,
        },
        query: {
          category: name,
        },
      });
    },
    openNewsItem(categoryType, id, articleName) {
      // Push category id to router and "NewsCategory.vue" component.
      // - Id used to fetch the category type from strapi
      const category = formatUrl(categoryType);
      const categoryName = categoryType;

      const name = formatUrl(articleName);
      const formattedName = articleName;

      router.push({
        name: "News Item",
        params: {
          category,
          categoryName,
          id,
          name,
          formattedName,
        },
        query: {
          name: name,
        },
      });
    },
  },
  mounted() {
    this.fetchNewsCategories();
  },
};
</script>
